const locale = {
	CLEANING: 'Cleaning',
    CLEANING_SESSIONS: 'Cleaning Sessions',
    EXPRESS_CLEANING: 'Express Cleaning',
    NO_EXPRESS_CLEANING_ROOMS: 'There are currently no rooms marked for express cleaning',
    CHECKOUT_CLEANING: 'Checkout Cleaning',
    NO_CHECKOUT_CLEANING_ROOMS: 'There are currently no rooms marked for checkout cleaning',
    DIRTY_ROOMS: 'Dirty Rooms',
    CLEANED_ROOMS: 'Cleaned Rooms',
    NO_DIRTY_ROOMS: 'Currently there are no rooms marked for cleaning',
    NO_CLEANED_ROOMS: 'Currently there are no rooms cleaned',
    CURRENTLY_CLEANING: 'Currently Cleaning',
    NO_CURRENTLY_CLEANING_ROOMS: 'No rooms are currently being cleaned',
    
    // Notification translations
    ROOM_ASSIGNED_TITLE: 'New Room Assignment',
    ROOM_ASSIGNED_BODY: 'You have been assigned {{count}} room(s): {{rooms}}',
    ROOM_REASSIGNED_FROM_TITLE: 'Rooms Reassigned',
    ROOM_REASSIGNED_FROM_BODY: '{{count}} room(s) reassigned to {{newCleaner}}: {{rooms}}',
    ROOM_REASSIGNED_TO_TITLE: 'New Room Assignment',
    ROOM_REASSIGNED_TO_BODY: '{{count}} room(s) reassigned from {{oldCleaner}}: {{rooms}}',
    ROOM_ASSIGNMENT_REMINDER_TITLE: 'Room Assignment Reminder',
    ROOM_ASSIGNMENT_REMINDER_BODY: 'You have {{count}} room(s) to clean today: {{rooms}}',
    ROOM_ASSIGNMENT_UPDATE_TITLE: 'Room Assignment Update',
    ROOM_ASSIGNMENT_UPDATE_BODY: 'Your room assignments have been updated: {{rooms}}',

    SELECT_A_FLOOR: 'Select a floor',
    ALL: 'All floors',
    FLOOR_NUMBER: "Floor {{number}}",

    Clean: 'Cleaned',
    Dirty: 'Dirty',
    Cleaning: 'Cleaning',
    Express : 'Express Cleaning',
    Maintenance: 'Maintenance',
    Inspection: 'Inspection',
    Completed: 'Completed',
    Cancelled: 'Cancelled',
    Paused: 'Paused',
    Reported: 'Reported',
    'Awaiting Fixing': 'Awaiting Fixing',
    Fixing: 'Fixing',
    Fixed: 'Fixed',
    Pending: 'Pending',
    Approved: 'Approved',
    Rejected: 'Rejected',
    Assigned: 'Assigned',
    Skipped: 'Skipped',
    Reassigned: 'Reassigned',
    CANCEL_THE_REQUEST: 'Cancel the request',
    MARK_AS_DIRTY: 'Mark as dirty',
    START_CLEANING: 'Start cleaning',
    CHECK: 'Check',
    ROOM_NUMBER: 'Room number:',
    VIEW_CLEANING: 'View cleaning',
    ELAPSED_TIME: 'Cleaning time',

    MAINTENANCE: 'Maintenance',
    CLOSE: 'Close',
    CONFIRM: 'Confirm',
    SUCCESS_MAINTENANCE: 'The maintenance request has been sent successfully',
    CHOOSE_MAINTENANCE: 'Choose what needs to be replaced or repaired in the corresponding room',

    ADD_COMMENT: 'Add comment',
    END_CLEANING: 'End cleaning',
    HISTORY: 'History',
    NO_HISTORY: 'No history',
    FULL_HISTORY: 'Full history',
    EXISTING_EVALUATION: 'Existing Evaluation',
    SUBMIT_EVALUATION: 'Submit Evaluation',
    RATING: 'Rating',
    RATING_COMMENTS: 'Rating comments',
    REASSIGNMENT_REASON: 'Reason for reassignment',
    REASSIGNMENT_REASON_PLACEHOLDER: 'Explain why this cleaning needs to be reassigned...',
    REASSIGNMENT_REASON_REQUIRED: 'Reason is required when reassigning',
    REASSIGNMENT_SUBMITTED_SUCCESS: 'Reassignment submitted successfully!',
    REASON_FOR_REASSIGNMENT: 'Reason for reassignment',
    REASSIGNED: 'Reassigned for re-cleaning',
    NOT_REASSIGNED: 'Not assigned for re-cleaning',
    REASSIGN_CLEANING: 'Аssign for re-cleaning',
    SUBMIT_REASSIGNMENT: 'Assign for re-cleaning',
    REASSIGNED_DUE_TO: 'Reassigned due to:',
    ROOM_RETURNED_FOR_RECLEANING: 'Room Returned for Re-Cleaning',
    MAIN_CLEANER_FEEDBACK: 'Main Cleaner\'s Feedback',
    RETURNED: 'Returned',
    RETURNED_ROOM_TOOLTIP: 'This room was returned for re-cleaning today. Start cleaning to see the Main Cleaner\'s feedback.',

    ALREADY_CLEANING: "Already cleaning",
    ANOTHER_CLEANER_TIP: "Another cleaner is already cleaning this room.",
    ALREADY_CLEANING_TIP: "You already have an active cleaning session.",
    ROOM_ALREADY_CLEAN: "Room is already clean",

    NO_NOTES_AVAILABLE: 'No notes available',
    NO_SESSIONS_FOUND: 'No cleaning sessions found',
    SEARCH_SESSIONS: 'Search by room, cleaning employee, or notes...',
    ROOM: 'Room',
    FLOOR: 'Floor', 
    CLEANER: 'Cleaning Employee',
    START_TIME: 'Start Time',
    END_TIME: 'End Time',
    DURATION: 'Duration',
    STATUS: 'Status',
    LOADING: 'Loading...',
    NO_COMMENTS: 'No comments',
    
    // Cleaning Checklist
    CLEANING_CHECKLIST: 'Cleaning Checklist',
    NO_CHECKLIST_AVAILABLE: 'No checklist available for this room type',
    COMPLETION_PROGRESS: 'Progress',
    REQUIRED_ITEMS: 'Required Items',
    REQUIRED: 'Required',
    ADD_NOTES: 'Add notes',
    OPTIONAL_NOTES_PLACEHOLDER: 'Add optional notes about this task...',
    COMPLETED_AT: 'Completed at',
    ALL_REQUIRED_ITEMS_COMPLETED: 'All required items have been completed!',
    LEAVE_COMMENT: 'Leave a comment',
    CHECKLIST_PROGRESS: 'Checklist Progress',
    CHECKLIST_ITEMS: 'Checklist Items', 
    NO_CHECKLIST: 'No Checklist',
    NOTES: 'Notes',
    STANDARD_ROOM: 'Standard Room',

    // Checklist category options
    CHECKLIST_BEDROOM: 'Bedroom',
    CHECKLIST_BATHROOM: 'Bathroom',
    CHECKLIST_BOTH: 'Both',
    CHECKLIST_GENERAL: 'General',

    // Main Cleaner specific translations
    ROOM_STATUS_INFO: 'Room Status Information',
    SUPERVISOR_FEEDBACK: 'Supervisor Feedback',
    SUPERVISOR_COMMENT_PLACEHOLDER: 'Leave your feedback about this room\'s cleaning status...',
    SUBMIT_FEEDBACK: 'Submit Feedback',
    SUBMITTING: 'Submitting...',
    NO_SUPERVISOR_FEEDBACK: 'No supervisor feedback',
    LATEST_CLEANING_SESSION: 'Latest Cleaning Session',
    NO_CLEANING_SESSION_FOUND: 'No cleaning sessions found for this room',
    NO_CLEANING_SESSION_TODAY: 'No cleaning sessions found for this room today',
    UNKNOWN_USER: 'Unknown User',
    EXISTING_SUPERVISOR_COMMENT: 'Previous Supervisor Comment',
    ASSIGNED_TO: 'Assigned to',
    NOT_ASSIGNED: 'Not assigned',
    ESTIMATED_TIME: 'Est. time',
    CLEANING_DATE: 'Cleaning Date',

 // Main Cleaner No Room Access
 NO_ROOMS_ASSIGNED_TITLE: 'No Rooms Assigned',
 NO_ROOMS_ASSIGNED_DESCRIPTION: 'You don\'t have access to any rooms yet. Please contact your administrator to assign rooms to you.',
 CONTACT_ADMINISTRATOR: 'Contact Administrator',

 // Auto-completion messages
 AUTO_COMPLETED_MIDNIGHT: 'Auto-completed: Session passed midnight without manual completion.',

    // Rating and Reassignment translations
    RATE_CLEANING: 'Rate this cleaning',
    CLEANING_RATING: 'Quality of cleaning',
    RATING_COMMENT: 'Additional comments (optional)',
    RATING_COMMENT_PLACEHOLDER: 'Add any specific feedback about the cleaning quality...',

    REASSIGN_TO_ORIGINAL_CLEANER: 'Reassign to original cleaner',
    SUBMIT_RATING_AND_REASSIGNMENT: 'Submit Rating & Reassignment',
    SUBMIT_RATING_REASSIGNMENT: 'Submit Rating & Reassignment',
    SUBMIT_RATING: 'Submit Rating',
    RATING_SAVED_SUCCESS: 'Rating has been saved successfully',
    RATING_SUBMITTED_SUCCESS: 'Rating and feedback submitted successfully!',
    RATING_SUBMIT_ERROR: 'Failed to submit rating. Please try again.',
    RATING_AND_REASSIGNMENT_SUCCESS: 'Rating saved and room reassigned successfully',
    RATING_SAVE_FAILED: 'Failed to save rating. Please try again.',
    ALREADY_EVALUATED: 'This cleaning session has already been evaluated',
    SESSION_NOTES: 'Session Notes',

    // Room Types
    SINGLE_ROOM: 'Single Room',
    DOUBLE_ROOM: 'Double Room',
    TWIN_ROOM: 'Twin Room',
    TRIPLE_ROOM: 'Triple Room',
    QUEEN_ROOM: 'Queen Room',
    KING_ROOM: 'King Room',
    STUDIO_ROOM: 'Studio Room',
    SUITE: 'Suite',
    JUNIOR_SUITE: 'Junior Suite',
    PRESIDENTIAL_SUITE: 'Presidential Suite',

    // Checklist access control
    CHECKLIST_ACCESS_DENIED: 'Checklist Access Denied',
    CHECKLIST_ACCESS_DENIED_MESSAGE: 'The checklist viewing has been disabled for Cleaners. Please contact your administrator for assistance.',
};

export default locale;
